import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { initialiseSearchStore } from "./initialise-search-store";
import { SearchStoreContext } from "./use-search-store";
export const SearchStoreProvider = ({ children , params , isInsideStoryblok , allCinchStores , pathSegmentsFromUrl  })=>{
    const storeRef = useRef();
    if (!storeRef.current) {
        storeRef.current = initialiseSearchStore({
            params,
            isInsideStoryblok,
            allCinchStores,
            pathSegmentsFromUrl
        });
    }
    return /*#__PURE__*/ _jsx(SearchStoreContext.Provider, {
        value: storeRef.current,
        children: children
    });
};
